import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { all_routes } from "../router/all_routes";
import GoalTracking from "./goalSelf";
import GoalType from "./goalType";
import GoalAssign from "./goalteam";
import Goalpage from "./goalpage";

const Goal = () => {
  const [activeTab, setActiveTab] = useState("self");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const routes = all_routes;

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Goals</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Performance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Goals
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Breadcrumb */}

          {/* Tabs Section */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-end">
              <button
                className={`btn btn-${
                  activeTab === "self" ? "primary" : "light"
                } mx-1`}
                onClick={() => setActiveTab("self")}
              >
                My Goals
              </button>

              <button
                className={`btn btn-${
                  activeTab === "team" ? "primary" : "light"
                } mx-1`}
                onClick={() => setActiveTab("team")}
              >
                Team Goals
              </button>

              <Dropdown
                isOpen={dropdownOpen}
                toggle={toggleDropdown}
                className="mx-1"
              >
               <DropdownToggle
                caret
                className={`btn btn-${
                  activeTab === "goalType" || activeTab === "goal"
                  ? "primary"
                : "light"
                }`}
               >
               {activeTab === "goalType"
                ? "Goal Type"
                 : activeTab === "goal"
                 ? "Goal"
                : "Goals"}
               </DropdownToggle>


                <DropdownMenu>
                  <DropdownItem
                    active={activeTab === "goal"}
                    className={
                      activeTab === "goal" ? "bg-primary text-white" : ""
                    }
                    onClick={() => setActiveTab("goal")}
                  >
                    Goal
                  </DropdownItem>

                  <DropdownItem
                    active={activeTab === "goalType"}
                    className={
                      activeTab === "goalType" ? "bg-primary text-white" : ""
                    }
                    onClick={() => setActiveTab("goalType")}
                  >
                    Goal Type
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className="p-3 w-100 h-100">
              {activeTab === "self" && <GoalTracking />}
              {activeTab === "goalType" && <GoalType />}
              {activeTab === "goal" && <Goalpage />}
              {activeTab === "team" && <GoalAssign />}
            </div>
          </div>
          {/* /Tabs Section */}
        </div>

        {/* Footer */}
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default Goal;
